import React from "react";
import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import { CalculateStore } from "../../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import TextInput from "../../../sharedComponents/textInput/textInput";
import { displayAdditionalRiskForm, RisksNetworkTypes } from "../../../../helpers/risksNetwork";
import { AdditionalInsurancesName } from "../../../../helpers/additionalInsurances";
import Notification from "../../../sharedComponents/notification/notification";

interface SecondOpinionProps {
  calculateStore?: CalculateStore;
}

@inject("calculateStore")
@observer
export default class SecondOpinion extends React.Component<SecondOpinionProps, any> {
  public render() {
    const secondOpinionWarning = AdditionalInsurancesName[RisksId.secondOpinionExtension].displayNotification;
    const calculateStore = this.props.calculateStore!;
    const secondOpinionExtension = calculateStore.additionalInsurances.secondOpinionExtension;
    const secondOpinion = calculateStore.additionalInsurances.secondOpinion;
    const displayRate = displayAdditionalRiskForm(secondOpinionExtension);
    const additionalInfoDisabled = secondOpinionExtension.risksNetworkValue === RisksNetworkTypes.notAvailable &&
      secondOpinion.risksNetworkValue === RisksNetworkTypes.notAvailable;
    return (
      <div className="section second-opinion">
        <RiskName riskId={RisksId.secondOpinion}
          displayIcon={true}
          checkboxOnChange={(event) => {
            calculateStore.setAdditionalInsuranceFieldChecked(RisksId.secondOpinion, event.target.checked);
          }}
        />

        <div className="second-opinion-extension">
          <RiskName riskId={RisksId.secondOpinionExtension}
            displayIcon={false}
            checkboxOnChange={(event) => {
              calculateStore.setAdditionalInsuranceFieldChecked(RisksId.secondOpinionExtension, event.target.checked);
            }}
          />

          {displayRate && (
            <TextInput
              disabled={true}
              className="rate"
              value={secondOpinionExtension.rate || "?"}
              topLabel="Składka (zł)"
            />
          )}
        </div>

        <div >
          {!displayRate && (
            <div className="risk-name-wrapper">
              <div className="risk-name">
                <div className="risk-name-content">
                  <Notification type="info" message={secondOpinionWarning?.toString()} />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={`additional-info ${additionalInfoDisabled ? "disabled" : ""}`}>
          * w wieku do 65 lat
        </div>
      </div>
    );
  }
}
